/* ----------------------------------------------- */
/*   Reusable selectors to use in mapStateToProps
/*   so that the props only change when the actual bit of state they depend on changes
/*   https://redux.js.org/recipes/computing-derived-data
/*   https://redux-starter-kit.js.org/api/createselector
/*   https://github.com/reduxjs/reselect
/* ----------------------------------------------- */

import { createSelector } from 'redux-starter-kit';

const getFormData = (state, props) => state.mainForm.formData[props.formType];

const makeGetFormData = () => (createSelector(
  [getFormData],
  (formData) => (formData || {
    formSections: [],
  }),
));

export {
  makeGetFormData,
};
